import { createFileRoute } from "@tanstack/react-router";
import { ComingSoonPage } from "@/components/layout/page-container.tsx";

export const Route = createFileRoute("/tasks")({
  component: () => <ComingSoonPage title="任务管理" />,
});
